import { getFullUrl } from 'hubspot-url-utils';
import { createClient } from 'usage-tracker-core';
import { genericClient } from 'usage-tracker-core/client';
import { ensureFn } from 'usage-tracker-core/common/helpers';
import { sendEventsViaFetch } from 'usage-tracker-core/client/fetchClient';
import anonymousStorage from 'usage-tracker-core/containers/anonymousStorage';
const origin = getFullUrl('app-api');
const path = '/usage-logging/v1/log/hublytics-multi/no-auth';
const reportNetworkError = err => {
  return genericClient.reportError(err, {
    fingerprint: ['usage-tracker-js', 'network']
  });
};
const anonymousTrackingClient = createClient({
  clientName: 'anonymous',
  getDebug: genericClient.getDebug,
  getLang: genericClient.getLang,
  getTempStorage: anonymousStorage.getItem,
  setTempStorage: anonymousStorage.setItem,
  logWarning: genericClient.logWarning,
  logError: genericClient.logError,
  reportWarning: genericClient.reportWarning,
  reportError: genericClient.reportError,
  getHstc: () => null,
  getEmail: () => null,
  getHubId: () => null,
  send: ({
    events: data,
    query = '',
    onFailure
  }) => {
    const endpoint = `${origin}${path}?${query}`;
    const handleRequestFailure = error => {
      reportNetworkError(error);
      ensureFn(onFailure)();
    };
    const sendXhr = () => {
      sendEventsViaFetch(endpoint, {
        data
      }).catch(handleRequestFailure);
    };
    genericClient.sendBeacon(endpoint, data, sendXhr);
  }
});
export default anonymousTrackingClient;